import React from 'react';
import styled from '@emotion/styled'
import * as breakpoint from '../../styles/breakpoints.module.scss';

const EventCard = ({children}) => {

  return(
    <EventCardWrapper>
      <Card>
        {children}
      </Card>
    </EventCardWrapper>
  );

}

const Card = styled.div`
padding:48px 48px 0;
overflow:hidden;
box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
border-radius: 6px;
background: #FFFFFF;
border: 1px solid #CACACD;
height: 100%;
display: flex;
flex-direction: column;
justify-content: space-between;


@media only screen and (max-width: ${breakpoint.smMax}){
padding:24px 24px 0;
}

.top > div{
  .red{
    color:#D00F31;
  }
  .blue{
    color:#1976D2;
  }

  &:nth-of-type(1){
    color:#D00F31;
    font-weight: 900;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.05em;
    margin-bottom:16px;
  }

  &.year{
    color: #787880;
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
  }

  &.date{
    color: #222224;
    font-weight: 900;
    font-size: 36px;
    line-height: 44px;
    margin-bottom:28px;
  }
}

  .time{
    background:#F2F2F5;
    margin:48px -48px 0;
    padding:24px 48px;
    color: #444448;
    font-size: 16px;
    line-height: 20px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    
    .top > div{
      &:nth-of-type(1){
        font-size: 24px;
        line-height: 32px;
      }
      &.year{
        font-size: 14px;
        line-height: 20px;
      }
      &.date{
        font-size: 32px;
        line-height: 40px;
      }
      
    }

    .time{
      font-size: 16px;
      line-height: 20px;
      padding:16px 24px;
      margin:48px -24px 0;
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    
    .top > div{
      &:nth-of-type(1){
        font-size: 24px;
        line-height: 32px;
      }
      &.year{
        font-size: 14px;
        line-height: 20px;
      }
      &.date{
        font-size: 28px;
        line-height: 36px;
      }
    }

    .time{
      font-size: 12px;
      line-height: 16px;
      padding:16px 24px;
      margin:32px -24px 0;
    }
  }

`

const EventCardWrapper = styled.div`
  width:50%;

  &:nth-of-type(odd){
    padding-right:16px;
  }
  &:nth-of-type(even){
    padding-left:16px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;
    padding:8px 0 !important;
  }
`


export default EventCard;
